import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Cart } from '../view-products/cart.model';
import { AppConstant } from '../AppConstant';


@Injectable({
  providedIn: 'root'
})
export class ViewCartService {

  constructor(private httpClient : HttpClient) { }

   

  cart_URL='cart/';  
  Add_Customer_Details_URL= 'cart/viewCart';
  customer ='customer/';

  
  ViewCart(){
    console.log("In view cart service");
    console.log(AppConstant.baseURL + this.Add_Customer_Details_URL);
    return this.httpClient.get(AppConstant.baseURL + this.Add_Customer_Details_URL)
  }
  
  viewCartByCustomerId(customerId:number){
    console.log("In view cart by customer id service");
    console.log(AppConstant.baseURL + this.cart_URL+ this.customer + customerId);
    return this.httpClient.get(AppConstant.baseURL + this.cart_URL+this.customer + customerId);
  }

   viewCartByCartId(cartId:number){
    console.log("In view cart by cart id service");
    console.log(AppConstant.baseURL + this.cart_URL+ cartId);
    return this.httpClient.get(AppConstant.baseURL + this.cart_URL+cartId);
  }
}
